
<div class="shopStoreTEL">
  <a @click="openDialog" class="clickable" :class="linkClass">
    <slot></slot>
  </a>
  <div id="show-twilio-tel-dialog" @submit.prevent="postForm" class="ui tiny modal">
    <i class="close icon"></i>
    <div class="header">
      <p v-if="!formPosted">下記フォーム入力後、<span class="br">お店の電話番号が表示されます。</span></p>
      <p v-else>お店の電話番号</p>
    </div>
    <div class="content">
      <form v-if="!formPosted" class="ui form EventForm" :class="{'warning': form.hasErrors()}">
        <div class="EventForm__head">
          <h3 class="FormSubTitle">来店ご希望日、人数をお選びください</h3>
        </div>

        <div class="EventForm__body">
          <div class="EventForm__select">
            <div class="EventForm__pull left">
              <datepick v-model="form.model.event_date" :from="0" :placeholder="'ご希望日'"></datepick>
              <span class="vertical_line"></span>
            </div>

            <div class="EventForm__pull right">
              <select v-model="form.model.people">
                <option value="">概算人数</option>
                <option v-for="each in consts.MARUNAGE_PEOPLE" :value="each.value">{{ each.label }}</option>
              </select>
            </div>
          </div>
          <h3 class="FormSubTitle">電話番号（お客様確認で必要になります)</h3>
          <div class="required field" :class="{'error': form.hasError('tel')}">
          <input type="text" v-model="form.model.tel" placeholder="ご連絡先お電話番号" size="50" maxlength="50" class="phone--input">
          <validation-message :form="form" :field="'tel'"></validation-message> 
          </div>
        </div>
      </form>
      <div v-else>
        <div class="EventForm">
          <div class="EventForm__head">
            <h3 class="FormSubTitle--phone">{{ shopName }}</h3>
          </div>
          <p class="EventForm__body">
            <i id="phone" class="fas fa-phone fa-3x fa-flip-horizontal i-color"></i>
            <span class="p-number"><tel-link :value="twilioTel"></tel-link></span>
          </p>
        </div>
      </div>
    </div>
    <div v-if="!formPosted" class="actions">
      <div class="EventForm__foot">
        <a class="ui button" @click="postForm" :class="{'disabled': !isPostable}">番号を表示</a>
        <a class="ui cancel button">閉じる</a>
      </div>
    </div>
  </div>
</div>
